import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createDocument,
  getDocumentsByEntity,
  removeDocuments,
  updateDocument,
} from '../../services/farmMapping/documents'
import { queryKeys } from './queryKeys'

export const useDocuments = ({
  entityId,
  entityTypeId,
  documentsTypes,
}: {
  entityId: string | undefined
  entityTypeId?: number
  documentsTypes?: number[]
}) =>
  useQuery({
    queryKey: queryKeys.documents(entityId, entityTypeId, documentsTypes),
    queryFn: ({ signal }) =>
      getDocumentsByEntity({ entityId: entityId as string, entityTypeId, documentsTypes, signal }),
    enabled: !!entityId,
  })

// The document mutations run inside the caller's processLoading wrapper, which already surfaces
// failures through the loading modal — letting the global handler fire too would double-report.
const suppressGlobalError = { suppressGlobalError: true }

export const useCreateDocument = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createDocument,
    meta: suppressGlobalError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.documentsRoot })
    },
  })
}

export const useUpdateDocument = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateDocument,
    meta: suppressGlobalError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.documentsRoot })
    },
  })
}

export const useRemoveDocuments = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: removeDocuments,
    meta: suppressGlobalError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.documentsRoot })
    },
  })
}
